import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { PhoneNumberInput as PhoneNumberInputComponent } from '@dreryk/react-components';

import { personalDataTranslationKeys } from '../../../../../translations';

export type PhoneNumberValue = { phoneNumber: PhoneNumber | null };
type PhoneNumberInputProps = Pick<FormContextValues<PhoneNumberValue>, 'register'>;

export const PhoneNumberInput = (props: PhoneNumberInputProps): JSX.Element => {
   const controller = props.register('phoneNumber');

   return (
      <PhoneNumberInputComponent
         label={personalDataTranslationKeys.contactNumber}
         controller={controller}
         testId={'phoneNumber'}
      />
   );
};
